"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyState = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _EmptyImages = require("./EmptyImages");
var _EmptyStateModule = _interopRequireDefault(require("./EmptyState.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const EmptyState = exports.EmptyState = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    imageVariant,
    title,
    description,
    customImageUrl,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    "data-testid": "EmptyState",
    className: (0, _classify.default)(_EmptyStateModule.default.wrapper, classNames?.wrapper),
    ref: ref
  }), !!imageVariant && !customImageUrl && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_EmptyStateModule.default.image, classNames?.image)
  }, imageVariant === 'calendar' && /*#__PURE__*/React.createElement(_EmptyImages.CalendarEmptyImage, null), imageVariant === 'data' && /*#__PURE__*/React.createElement(_EmptyImages.DataEmptyImage, null), imageVariant === 'file' && /*#__PURE__*/React.createElement(_EmptyImages.FileEmptyImage, null), imageVariant === 'message' && /*#__PURE__*/React.createElement(_EmptyImages.MessageEmptyImage, null), imageVariant === 'upload' && /*#__PURE__*/React.createElement(_EmptyImages.UploadEmptyImage, null), imageVariant === 'chart' && /*#__PURE__*/React.createElement(_EmptyImages.ChartEmptyImage, null)), customImageUrl && /*#__PURE__*/React.createElement("img", {
    className: (0, _classify.default)(_EmptyStateModule.default.image, classNames?.image),
    src: customImageUrl,
    alt: "Empty State"
  }), !!title && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_EmptyStateModule.default.title, classNames?.title)
  }, title), !!description && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_EmptyStateModule.default.description, classNames?.description)
  }, description), !!children && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_EmptyStateModule.default.childrenWrapper, classNames?.children)
  }, children));
});